module.exports = __webpack_public_path__ + "img/AlfredNobel.adc36cb4.jpg";